import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button, CircularProgress, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";

import { SUPER_ADMIN } from "common/constant";
import InputFieldText from "Components/Common/InputFieldText";
import Tooltip from "Components/Common/Tooltip";

import { usePutUpdateProjectLocationMutation } from "apis/ProposedProjectLocation";

const ProposedProjectLocationEditField = ({
  applicationId,
  proposedProjectLocation: proposedProjectLocationName,
  t,
}) => {
  const [isEditingLocation, setIsLocationEditing] = useState(false);
  const [proposedProjectLocation, setProposedProjectLocation] = useState(
    proposedProjectLocationName
  );
  const [error, setError] = useState("");
  const { roles } = useSelector((state) => state.Login);

  const [changeProposedLocation, { isLoading: isChangingLocation }] =
    usePutUpdateProjectLocationMutation();

  const updateProposedProjectLocation = async (query) => {
    try {
      await changeProposedLocation(null, query);
      setIsLocationEditing(false);
    } catch (error) {}
  };

  const handleProposedProjectLocation = async () => {
    try {
      await updateProposedProjectLocation({
        applicationId,
        proposedProjectLocation,
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (
      proposedProjectLocationName &&
      proposedProjectLocation !== proposedProjectLocationName
    ) {
      setProposedProjectLocation(proposedProjectLocationName);
    }
  }, [proposedProjectLocationName]);

  if (!roles.includes(SUPER_ADMIN)) {
    return proposedProjectLocationName ?? "-";
  }

  if (!isEditingLocation) {
    return proposedProjectLocationName ? (
      <>
        {proposedProjectLocationName}

        <IconButton
          sx={{ padding: "5px" }}
          onClick={() => setIsLocationEditing(true)}
        >
          <Tooltip title={t("Change Proposed Project Location")}>
            <EditIcon fontSize="small" />
          </Tooltip>
        </IconButton>
      </>
    ) : (
      "-"
    );
  }

  return (
    <div className="d-flex gap-2">
      <div className="flex-grow-1">
        <InputFieldText
          label={t("Address of proposed project location") + "*"}
          name="solar.proposedProjectLocation"
          value={proposedProjectLocation}
          onChange={(e) => {
            setProposedProjectLocation(e.target.value);
            if (e.target.value) {
              setError("");
            } else {
              setError("Proposed project location is required");
            }
          }}
          errorMessage={error}
        />
      </div>
      <Button
        variant="outlined"
        size="small"
        sx={{ height: "40px" }}
        disabled={
          isChangingLocation ||
          proposedProjectLocation === proposedProjectLocationName ||
          !!error
        }
        onClick={handleProposedProjectLocation}
      >
        Save
        {isChangingLocation && <CircularProgress size={20} className="ms-2" />}
      </Button>
    </div>
  );
};

ProposedProjectLocationEditField.propTypes = {
  applicationId: PropTypes.string,
  proposedProjectLocation: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(ProposedProjectLocationEditField);
